import { render, staticRenderFns } from "./MyCp3.vue?vue&type=template&id=8958efee&scoped=true&"
import script from "./MyCp3.vue?vue&type=script&lang=js&"
export * from "./MyCp3.vue?vue&type=script&lang=js&"
import style0 from "./MyCp3.vue?vue&type=style&index=0&id=8958efee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958efee",
  null
  
)

export default component.exports